import {
  ButtonDS,
  EditOutlined,
  Spacer,
  TextCapitalized,
  dateFormatterDayMonthYearLong2Digits,
} from "@qivia/ui";
import { SidePanelDS } from "@qivia/ui";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ManagerDataDisplayRow } from "../usersAPI";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import "../../../../i18n/i18n";

export const SidePanelUserDetails = (props: {
  manager: ManagerDataDisplayRow;
  canUpdateRole: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onUpdateRole = useCallback(() => {
    if (props.manager.uuid) {
      navigate(`/home/user_update_role/${props.manager.uuid}`);
    }
  }, [navigate, props.manager.uuid]);

  const invitationDate = useMemo(() => {
    if (!props.manager.requestedAt) {
      return null;
    }
    return dateFormatterDayMonthYearLong2Digits(
      new Date(props.manager.requestedAt),
    );
  }, [props.manager.requestedAt]);

  return (
    <>
      <TextCapitalized>
        <StyledSectionTitle>
          {t("users.management.sidePanel.details.title")}
        </StyledSectionTitle>
      </TextCapitalized>
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("users.management.sidePanel.details.requestedAt")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={invitationDate || "—"}
      />
      <Spacer y={1} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("users.management.sidePanel.details.role")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={
          <StyledRoleRow>
            <TextCapitalized>
              {t(`users.management.sidePanel.role.${props.manager.role}.title`)}
            </TextCapitalized>
            {props.canUpdateRole ? (
              <>
                <Spacer x={0.5} />
                <ButtonDS
                  singleIcon={{ icon: <EditOutlined />, size: "S" }}
                  format="hug"
                  buttonType="tertiary"
                  onClick={onUpdateRole}
                />
              </>
            ) : null}
          </StyledRoleRow>
        }
      />
      <Spacer y={1} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("users.management.sidePanel.details.job")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={props.manager.job || "—"}
      />
    </>
  );
};

const SectionRowLabel = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/black"]}
`;

const StyledSectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledRoleRow = styled.div`
  display: flex;
  align-items: center;
  min-height: 2.5rem;
`;
